import type { ReactNode } from 'react'

interface OrphanRemoverProps {
  textBlock: string
}

export function OrphanRemover({ textBlock }: OrphanRemoverProps): ReactNode {
  // this component will take the last two words in a text and
  // put the last two in a span tag in order to stop orphans from appearing
  // span tags dont mess with SEO

  if (!textBlock || textBlock.length < 0) {
    return <>{textBlock}</>
  }

  const words = textBlock.trim().split(' ')
  const totalWords = words.length

  // if there are fewer than four words then don't do anything -
  // otherwise we will end up with an orphan on the first line instead (!)
  if (totalWords < 4) {
    return <>{textBlock}</>
  }

  const formattedLastWords = `${words[totalWords - 2]} ${words[totalWords - 1]}`
  words.splice(-2, 2)

  return (
    <span>
      {words.join(' ')} <span style={{ whiteSpace: 'nowrap' }}>{formattedLastWords}</span>
    </span>
  )
}
